import env from "react-dotenv";

const hostUrl = env.HOST_URL;

export default hostUrl;